"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _PageEventTracker = _interopRequireDefault(require("../event-trackers/PageEventTracker"));
var _AppEventTracker = _interopRequireDefault(require("../event-trackers/AppEventTracker"));
var _EventTracker = _interopRequireDefault(require("../event-trackers/EventTracker"));
var _configOptions = require("../constants/config-options");
var _defaultConfig = require("../config/default-config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // Copyright 2019 Amplify Inc. All Rights Reserved.
/**
 * @fileoverview TrackingService can be used to instrument client-side JS apps with generic xAPI eventing.
 *
 * Currently, the following events are captured:
 *
 * - App loaded:   Sent when TrackingService is first initialized.
 * - App unloaded: Sent when app unloads. The event may be stashed and sent only when the app next loads; this should
 *                 prevent the event from being lost if app unloads before sending.
 * - Page opened:  Sent each time the app URL changes, with the new URL.
 * - Page closed:  Sent each time the app URL changes, with the previous URL.
 *
 * @author jgraham@amplify.com (Jessica Graham)
 */
var TrackingService = /*#__PURE__*/function () {
  /** Initialize the module with an instance of EventService and tracking configuration options.
   *
   * @param {EventService} eventService
   * @param {Object} trackingConfig
   */
  function TrackingService(eventService, trackingConfig) {
    _classCallCheck(this, TrackingService);
    this.trackingConfig = Object.assign({}, _defaultConfig.defaultTrackingConfig, trackingConfig);

    // Initialize trackers.
    this.appEventTracker = new _AppEventTracker["default"](eventService, this.trackingConfig);
    this.pageEventTracker = new _PageEventTracker["default"](eventService, this.trackingConfig);
    this.customEventTrackers = [];
  }

  /**
   * Start tracking events.
   */
  _createClass(TrackingService, [{
    key: "start",
    value: function start() {
      this.appEventTracker.start();
      this.pageEventTracker.start();
      if (this.trackingConfig[_configOptions.TRACKING_OPTIONS.AUTO_UNLOAD]) {
        // Stop tracking on unload.
        window.addEventListener('beforeunload', this.stop.bind(this));
      }
      // Start custom trackers
      this.customEventTrackers.forEach(function (tracker) {
        return tracker.start();
      });
    }

    /**
     * Stop tracking events.
     */
  }, {
    key: "stop",
    value: function stop() {
      this.appEventTracker.stop();
      this.pageEventTracker.stop();

      // Stop custom trackers
      this.customEventTrackers.forEach(function (tracker) {
        return tracker.stop();
      });
    }

    /**
     * Add context extensions
     *
     * @param {Object} extensions Object of extensions to add.
     * **/
  }, {
    key: "addContextExtensions",
    value: function addContextExtensions(extensions) {
      this.appEventTracker.addContextExtensions(extensions);
      this.pageEventTracker.addContextExtensions(extensions);
      this.customEventTrackers.forEach(function (tracker) {
        tracker.addContextExtensions(extensions);
      });
    }

    /**
     * Add result extensions
     *
     * @param {Object} extensions Object of extensions to add.
     * **/
  }, {
    key: "addResultExtensions",
    value: function addResultExtensions(extensions) {
      this.appEventTracker.addResultExtensions(extensions);
      this.pageEventTracker.addResultExtensions(extensions);
      this.customEventTrackers.forEach(function (tracker) {
        tracker.addResultExtensions(extensions);
      });
    }

    /**
     * Add custom tracker
     *
     * @param {EventTracker} eventTracker Customer tracker.
     * **/
  }, {
    key: "addTracker",
    value: function addTracker(eventTracker) {
      if (eventTracker instanceof _EventTracker["default"]) {
        this.customEventTrackers.push(eventTracker);
      } else {
        throw new Error(eventTracker.constructor.name + ' does not extend EventTracker');
      }
    }

    /**
     * Add custom tracker array
     *
     * @param {EventTracker[]} eventTrackers Array of customer trackers.
     * **/
  }, {
    key: "addTrackers",
    value: function addTrackers(eventTrackers) {
      var _this = this;
      if (eventTrackers.constructor === Array) {
        eventTrackers.forEach(function (tracker) {
          return _this.addTracker(tracker);
        });
      } else {
        throw new Error(eventTrackers.constructor.name + ' is not an Array');
      }
    }
  }]);
  return TrackingService;
}();
var _default = TrackingService;
exports["default"] = _default;
module.exports = exports.default;